import React from 'react'
import { InvoiceConfigMain } from './components/InvoiceConfigMain'
import { InvoiceConfigProvider } from './context/InvoiceConfigProvider'
import { InvoiceConfigWorkflowsProvider } from './context/InvoiceConfigWorkflowsProvider'
import { CreateInvoiceConfigFlow } from './workflows/CreateInvoiceConfigFlow'
import { EditInvoiceConfigFlow } from './workflows/EditInvoiceConfigFlow'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'

export const InvoiceConfig = () => {
  return (
    <NuqsAdapter>
      <InvoiceConfigProvider>
        <InvoiceConfigWorkflowsProvider>
          <InvoiceConfigMain />
          <CreateInvoiceConfigFlow />
          <EditInvoiceConfigFlow />
        </InvoiceConfigWorkflowsProvider>
      </InvoiceConfigProvider>
    </NuqsAdapter>
  )
}
